import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { Meta } from '@angular/platform-browser';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, first, tap } from 'rxjs/operators';
import { Userpilot } from 'userpilot';

import { CustomIconService } from '@app/services/custom-icon.service';
import { PuSubscribable } from '@app/utils/pu-subscribe';
import { AuthService } from '@shared/services/auth.service';

import { DeepLinkService } from './services/deep-link.service';
import { environment } from '../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends PuSubscribable implements OnInit {
  environment = environment;
  isAuthenticated = false;

  constructor(
    private metaService: Meta,
    customIconService: CustomIconService,
    iconRegistry: MatIconRegistry,
    private router: Router,
    private authService: AuthService,
    private deepLinkService: DeepLinkService
  ) {
    super();
    customIconService.registerIcons();
    iconRegistry.setDefaultFontSetClass('material-icons');
  }

  ngOnInit() {
    Userpilot.initialize('NX-1c7a6f3e');
    this.authService.checkConfigId();
    this.deepLinkService.initializeDeepLinkHandler();

    this.metaService.addTag(
      {
        name: 'author',
        content: this.environment.ver,
      },
      true
    );

    this.router.events
      .pipe(
        untilDestroyed(this),
        filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel),
        first(),
        tap(() => {
          document.getElementById('initial-app-loader').remove();
        })
      )
      .subscribe()
      .untilDestroyed(this);
  }
}
